
import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CardDescriptionProps {
  description?: string;
  maxLength?: number;
  maxResidents?: number;
  className?: string;
  category?: string;
}

export function CardDescription({ description, maxLength = 120, maxResidents, className, category }: CardDescriptionProps) {
  // Function to truncate text and add ellipsis if it exceeds the given length
  const truncateText = (text: string | undefined, maxTextLength: number): string => {
    if (!text) return '';
    return text.length > maxTextLength ? `${text.substring(0, maxTextLength)}...` : text;
  };

  const truncatedDescription = truncateText(description, maxLength);
  const needsTruncation = description && description.length > maxLength;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            {category && (
              <p className="text-xs text-grandpal-green font-medium mb-1">
                {category}
              </p>
            )}
            <p className={`text-sm text-grandpal-gray mb-2 line-clamp-3 min-h-[40px] ${className || ''}`}>
              {truncatedDescription || "No description available"}
            </p>
            {maxResidents && (
              <p className="text-xs text-grandpal-gray">
                <span className="font-medium">Capacity:</span> {maxResidents} residents
              </p>
            )}
          </div>
        </TooltipTrigger>
        {needsTruncation && (
          <TooltipContent className="max-w-xs">
            {description}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
